"use client";

import { c as _c } from "react/compiler-runtime";
import { PlayIcon } from "@heroicons/react/24/solid";
import { Button, cn, Dialog, DialogContent, DialogTitle, DialogTrigger } from "@saridana-core/react-ui-kit";
import { TTestimonyCard } from "@shared/types";
import Image from "next/image";
import { useRef, useState } from "react";
import { QuoteIcon } from "../custom-icon";
import { XMarkIcon } from "@heroicons/react/24/outline";
export function TestimonyDialog(t0) {
  const $ = _c(28);
  const {
    isOpen,
    selected,
    testimonies,
    onSelect,
    onOpenChange
  } = t0;
  const [isOverflowing, setIsOverflowing] = useState(false);
  const scrollRef = useRef(null);
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = open => {
      if (onOpenChange) {
        onOpenChange(open);
      }
      if (open) {
        setTimeout(() => {
          const el = scrollRef.current;
          if (!el) {
            return;
          }
          const hasOverflow = el.scrollWidth > el.clientWidth;
          setIsOverflowing(hasOverflow);
        }, 100);
      }
    };
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[2] !== onSelect) {
    t2 = testimony => {
      if (testimony && onSelect) {
        onSelect(testimony);
      }
    };
    $[2] = onSelect;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSelect = t2;
  const t3 = !!isOpen;
  const t4 = !!isOpen;
  let t5;
  if ($[4] !== handleOpenChange) {
    t5 = () => handleOpenChange(false);
    $[4] = handleOpenChange;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <XMarkIcon className="size-6" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <Button variant="outline" className="bg-white text-gray-900 size-10 sm:size-12 fixed top-6 right-4 md:right-6 lg:top-10 lg:right-10" onClick={t5}>{t6}</Button>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DialogTitle className="hidden" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== selected?.videoUrl) {
    t9 = selected?.videoUrl && <div className="relative overflow-hidden rounded-2xl mt-5 sm:mt-6"><iframe width="966" height="543" src={selected?.videoUrl} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
        background: "#000"
      }} allowFullScreen={true} className="w-full" /></div>;
    $[10] = selected?.videoUrl;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== handleSelect || $[13] !== isOverflowing || $[14] !== selected?.id || $[15] !== testimonies) {
    t10 = testimonies && testimonies.length > 0 && <div ref={scrollRef} className={cn("flex gap-3 sm:gap-4 mt-6 sm:mt-8 flex-nowrap overflow-x-auto", isOverflowing ? "justify-start" : "justify-center")}>{testimonies.map(item => <div className={cn("rounded-lg min-w-11 h-11 sm:min-w-14 sm:h-14 overflow-hidden border-2 cursor-pointer", selected?.id === item.id ? "border-primary" : "border-transparent")} key={item.id} onClick={() => handleSelect(item)}>{item.thumbnail && item.thumbnail.data && <Image src={item.thumbnail.data.attributes.url} alt={item.thumbnail.data.attributes.alternativeText || item.thumbnail.data.attributes.name} width={item.thumbnail.data.attributes.width || 312} height={item.thumbnail.data.attributes.height || 544} className={cn("object-cover object-center h-full w-full")} />}</div>)}</div>;
    $[12] = handleSelect;
    $[13] = isOverflowing;
    $[14] = selected?.id;
    $[15] = testimonies;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <div className="mx-auto w-full lg:w-[872px] py-6 px-4 sm:px-6">{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t7) {
    t12 = <DialogContent hideCloseButton={true} className="max-h-[100vh] overflow-y-auto sm:max-w-full !bg-transparent p-0 m-0">{t7}{t8}{t11}</DialogContent>;
    $[20] = t11;
    $[21] = t7;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== handleOpenChange || $[24] !== t12 || $[25] !== t3 || $[26] !== t4) {
    t13 = <Dialog open={t3} defaultOpen={t4} onOpenChange={handleOpenChange}>{t12}</Dialog>;
    $[23] = handleOpenChange;
    $[24] = t12;
    $[25] = t3;
    $[26] = t4;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
export function TestimonyCard(t0) {
  const $ = _c(16);
  const {
    subtitle,
    testimony,
    thumbnail,
    videoUrl,
    title,
    isActive,
    onClick
  } = t0;
  const t1 = isActive ? "p-2" : "p-2 md:p-0";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("w-full h-full overflow-hidden rounded-2xl bg-primary-600 flex flex-col md:flex-row items-stretch md:transition-all md:duration-500 md:ease-in-out", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isActive || $[3] !== onClick || $[4] !== thumbnail || $[5] !== videoUrl) {
    t3 = thumbnail?.data && <div className={cn("relative h-[342px] md:h-full overflow-hidden", isActive ? "md:min-w-[45%]" : "md:min-w-full")}><Image src={thumbnail.data.attributes.url} alt={thumbnail.data.attributes.alternativeText || thumbnail.data.attributes.name} width={thumbnail.data.attributes.width || 312} height={thumbnail.data.attributes.height || 544} className={cn("object-cover object-center h-full md:transition-all md:duration-500 md:ease-in-out rounded-2xl w-full", isActive ? "grayscale-0 md:scale-x-100" : "grayscale")} />{isActive && videoUrl && <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-center cursor-pointer z-10 hover:bg-gray-900/20 hover:opacity-80" onClick={() => onClick()}><div className="rounded-full inline-flex items-center justify-center text-center size-[65px] md:size-[120px]" style={{
          background: "linear-gradient(180deg, #1DB0DE 0%, #0D7097 100%)"
        }}><PlayIcon className="text-white size-10 md:size-16 ml-2" /></div></div>}</div>;
    $[2] = isActive;
    $[3] = onClick;
    $[4] = thumbnail;
    $[5] = videoUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isActive || $[8] !== subtitle || $[9] !== testimony || $[10] !== title) {
    t4 = subtitle && testimony && title && <div className={cn("px-2 md:px-6 py-1 mt-5 md:mt-0 text-white flex flex-col md:h-full flex-1 justify-between md:min-w-[55%] overflow-y-auto")}><div className={cn("flex-1 space-y-4 md:transition-all md:duration-500 md:ease-in-out", isActive ? "md:opacity-100 md:visible md:translate-y-0" : "md:opacity-0 md:invisible md:translate-y-2")}><QuoteIcon className="text-white size-8" /><div className="font-medium text-xl md:text-[28px] leading-[140%]">{testimony}</div></div><div className={cn("space-y-1 md:transition-all md:duration-500 md:ease-in-out mt-9 md:mt-0", isActive ? "md:opacity-100 md:visible md:translate-y-0" : "md:opacity-0 md:invisible md:translate-y-2")}><h4 className="font-semibold text-lg md:text-xl">{title}</h4><p className="opacity-80 font-normal text-lg">{subtitle}</p></div></div>;
    $[7] = isActive;
    $[8] = subtitle;
    $[9] = testimony;
    $[10] = title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}